// StatCard — compact metric tile with a small icon in the top-right.
// Extracted from Dashboard.jsx (Iter 92) so both the top-of-dashboard
// summary strip AND AnalyticsTab can share the same visual language
// without importing it via the parent.
export default function StatCard({ label, value, icon: Icon, testid }) {
  return (
    <div className="border border-border rounded-lg p-5 bg-card" data-testid={testid}>
      <div className="flex items-center justify-between mb-2">
        <div className="uppercase tracking-[0.2em] text-[10px] text-muted-foreground">{label}</div>
        <Icon className="w-4 h-4 text-sage"/>
      </div>
      <div className="font-display text-4xl tracking-tight">{value}</div>
    </div>
  );
}
